import React, { useState } from "react";
import {
  Button,
  FormControlLabel,
  Grid,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  makeStyles,
} from "@material-ui/core";
import { useSelector } from "react-redux";
import { ListaPresupuestosItem } from "./ListaPresupuestosItem";
import { Redirect } from "react-router-dom";
import { MENU_AUTORIZACIONES } from "../../../utils/constants";


const useStyles = makeStyles({
  root: {
    padding: 10,
    flexGrow: 1,
    marginTop: 10,
    // width: "100%",
  },
  input: {
    padding: 10,
  },
});



export const ListaPresupuestos = () => {
  const classes = useStyles();
  const {
    presupuestos: items,
  } = useSelector((state) => state.autorizaciones);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [dense, setDense] = useState(true);
  const [page, setPage] = useState(0);
  const [redirect, setRedirect] = useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const componentRef = React.useRef();

  const activeBreadcrumbValue = MENU_AUTORIZACIONES.BUSCADOR

  const reincio = () => {
    setRedirect(true)
  }

  console.log("presupuestos", items)
  return (
    <div className={classes.root}>
      {redirect && (
        <Redirect
          to={{
            pathname: '/autorizaciones',
            state: {
              from: '/autorizaciones/',
              activeBreadcrumb: activeBreadcrumbValue,
            },
          }}
        />
      )}
      <div
        style={{
          margin: '1rem 0',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex',
        }}
      >
        <Button variant="contained" color="primary" onClick={reincio}>
          Reiniciar buscador
        </Button>
      </div>
      <Grid item xs={12}>
        <TableContainer component={Paper} style={{ overflowX: "auto" }}>
          <Table size={dense ? "small" : "medium"} ref={componentRef}>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell align="left">Estado</TableCell>
                <TableCell align="left">Fecha Carga</TableCell>
                <TableCell align="left">N° Presupuesto</TableCell>
                <TableCell align="left">Tipo Presupuesto</TableCell>
                <TableCell align="left">Con Internación</TableCell>
                <TableCell align="left">Diagnostico</TableCell>
                <TableCell align="left">Practicas</TableCell>
                <TableCell align="left">Paciente</TableCell>
                <TableCell align="left">N° Afiliado</TableCell>
                <TableCell align="left">Seccional</TableCell>
                {/* <TableCell align="left">Bandeja</TableCell> */}
                <TableCell align="left">Tomada</TableCell>
                {/* {(parseInt(estadoPresupuestos) === AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_TERRENO || 
                parseInt(estadoPresupuestos) === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_PAIS ||
                parseInt(estadoPresupuestos) === AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA) &&        
                <TableCell align="left">Seguimiento</TableCell>
              } */}
                <TableCell align="left"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.length > 0 ? (
                // items.map((item) => (
                items
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item) => (
                    <ListaPresupuestosItem
                      item={item}
                      key={item.idPresupuesto?.toString()}
                      expandirPracticas={false}
                    />
                  ))
              ) : (
                <TableRow style={{ height: 50 }}>
                  <TableCell
                    colSpan={13}
                    style={{ textAlign: "-webkit-center" }}
                  >
                    {" "}
                    Sin Registros
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      {items.length > 0 && (
        <Grid item xs={12}>
          <TablePagination
            style={{ backgroundColor: "white" }}
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={items.length}
            rowsPerPage={rowsPerPage}
            labelRowsPerPage="Registros por página"
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
          <FormControlLabel
            control={
              <Switch
                checked={dense}
                onChange={(e) => setDense(e.target.checked)}
              />
            }
            label="Tamaño compacto"
          />
        </Grid>
      )}
    </div>
  )
}
